import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {campaignWorkflowInitialState} from './campaignBase.config';
import {CampaignWorkflowDataByStep} from 'common/src/modules/campaignWorkflow/campaignWorkflow.types';
import {SlimUser} from 'common/src/modules/users/users.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {SocialCampaignFlowStatus} from 'common/src/modules/externalAds/externalAds.types';

const campaignPageSlice = createSlice({
  name: BreadcrumbName.CampaignPage,
  initialState: campaignWorkflowInitialState,
  reducers: {
    resetCampaignWorkflow: () => campaignWorkflowInitialState,
    updateCampaignWorkflowDataByStep: (
      state,
      action: PayloadAction<CampaignWorkflowDataByStep>,
    ) => {
      state.campaignWorkflowDataByStep = action.payload;
    },
    updateCampaignWorkflowMappedUsers: (state, action: PayloadAction<Record<string, SlimUser>>) => {
      state.mappedUsers = action.payload;
    },
    updateSocialCampaignFlowStatus: (state, action: PayloadAction<SocialCampaignFlowStatus>) => {
      state.socialCampaignFlowStatus = action.payload;
    },
  },
});

export const {
  resetCampaignWorkflow,
  updateCampaignWorkflowDataByStep,
  updateCampaignWorkflowMappedUsers,
  updateSocialCampaignFlowStatus,
} = campaignPageSlice.actions;

export default campaignPageSlice.reducer;
